import { createElement } from "@max/max";
import { getFullScreenSize } from "@/utils/layout";
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import TopView from '@max/leez-top-view';
import { convertCentsToYuan, formatDate, MTNewDigitalDisplayStyle } from "@/utils/common";
import './index.scss';
// import VapView from "../vap-view";
// import { FREE_CARD_VAP } from "@/const";
// import { Animated } from '@max/mbc-animated';
// import AnimatedView from '@max/mbc-animate-view';
// import { useRef } from "@max/max";
// import { isTitansAppOrWebview } from "@nibfe/mkt-env-api";
import ModalBottomBtn from "../modal-bottom-button";
import { getSystemType, SystemType } from '@nibfe/mkt-env-api';
export default function FreeCardDrawResultPopup(props) {
    const { needAnimation = true } = props;
    const { fullScreenHeight, fullScreenWidth, toRateSize } = getFullScreenSize();
    // const opacity = useRef(new Animated.Value(0));
    // const amountTranslateY = useRef(new Animated.Value(toRateSize(140)));
    // const opacityValue = needAnimation ? opacity.current : 1;
    // const amountTranslateYValue = needAnimation ? amountTranslateY.current : 0;
    if (!props.freeOrderCardExtra) {
        return null;
    }
    const { hotelName, obtainAmount } = props.freeOrderCardExtra;
    // const Container = needAnimation ? View : LImage;
    const Container = View;
    const systemType = getSystemType();
    const isAndroid = systemType === SystemType.android;
    return <TopView>
      <ModalBaseContainer visible={props.visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        
        
        <Container 
    // source={{
    //   uri: 'https://p0.meituan.net/ingee/84ba79a9e5edae5b8eb2bd105b7e43c037624.png'
    // }}
    style={{
        width: '564rpx',
        height: '618rpx',
        display: 'flex',
        // paddingTop: needAnimation ? '318rpx' : '50rpx',
        overflow: 'visible',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
          <LImage source={{
        uri: 'https://p0.meituan.net/ingee/e2caa01dd0dde34e89c7282131f2985328927.png'
    }} style={{
        width: '321rpx',
        height: '125rpx'
    }} borderRadius={0}/>
          
          <View className="free-card-main-container">
            
              
              <Text className="free-card-order-info" numberOfLines={1}>
                订单：{hotelName}
              </Text>

              
              <Text className="free-card-date">
                {formatDate(props.freeOrderCardExtra.checkOutTime).hanStr}
              </Text>
            

            
            <View className="free-card-tag-use">
              <View className="free-card-tag-icon">
                <Text className="free-card-tag-text">免</Text>
              </View>
              <Text className="free-card-tag-desc">1房1晚·实付价</Text>
            </View>

            
            <View className="free-card-amount-container">
              
              <Text className="free-card-amount-symbol" style={Object.assign(Object.assign({}, MTNewDigitalDisplayStyle), { top: isAndroid ? '-25rpx' : '0rpx' })}>¥</Text>
              <Text className="free-card-amount-value" style={MTNewDigitalDisplayStyle}>
                {convertCentsToYuan(obtainAmount || 0, 2).integerPart}
              </Text>
              <Text className="free-card-amount-symbol" style={Object.assign(Object.assign({}, MTNewDigitalDisplayStyle), { top: isAndroid ? '-25rpx' : '0rpx' })}>.{convertCentsToYuan(obtainAmount || 0, 2).decimalPart}</Text>
              
            </View>

            
            
              <Text className="free-card-tip">
                {props.freeCardDesc}
              </Text>
            

            
            
            <View style={{
        marginTop: '80rpx'
    }}>
              <ModalBottomBtn buttonText="分享好运" onPress={props === null || props === void 0 ? void 0 : props.onShareFreeCard}/>
            </View>
            
          </View>

          
          
            <LImage onPress={props.onClose} source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx',
        marginTop: '60rpx'
    }} className="free-card-close-btn"/>
          
        </Container>

      </ModalBaseContainer>
    </TopView>;
}
